import { EventSourceParserStream as e } from "eventsource-parser/stream";
//#region src/stream/webAiStreamReader.ts
var t = async function* (t, n) {
	if (!t.body) throw Error("Response body is null — streaming not supported");
	let r = t.body.pipeThrough(new TextDecoderStream()).pipeThrough(new e()).getReader();
	try {
		for (;;) {
			let { done: e, value: t } = await r.read();
			if (e || n.aborted) break;
			yield {
				data: t.data,
				event: t.event,
				id: t.id
			};
		}
	} finally {
		r.releaseLock();
	}
};
//#endregion
export { t as webAiStreamReader };
